<template>
  <el-form :model="model" ref="loginForm" :rules="rules">
    <el-form-item>
      <el-alert
        :title="loginError"
        type="error"
        :closable="false"
        v-if="loginError"
      />
    </el-form-item>
    <el-form-item prop="username">
      <el-input
        v-model="model.username"
        size="large"
        :placeholder="$t('login.LOGIN.inputusername')"
        prefix-icon="User"
      />
    </el-form-item>
    <el-form-item prop="password">
      <el-input
        type="password"
        v-model="model.password"
        size="large"
        :placeholder="$t('login.LOGIN.inputpassword')"
        prefix-icon="Lock"
      />
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        size="large"
        style="width: 100%"
        :loading="loading"
        @click="login"
        >{{ $t('login.LOGIN.login') }}</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      rules: {
        username: [
          {
            required: true,
            message: this.$t('login.REGISTER.inputusername'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.REGISTER.inputpassword'),
            trigger: 'blur',
          },
        ],
      },
      model: {
        username: null,
        password: null,
      },
      loading: false,
      error: false,
      isValid: false,
    };
  },
  computed: {
    ...mapState('auth', {
      loginError: (state) => state.loginError,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    async login() {
      let isValid = false;
      await this.$refs.loginForm.validate(
        (valid) => (isValid = valid),
      );
      if (isValid) {
        this.loading = true;
        await this.$store.dispatch('auth/loginByUsername', this.model);
        this.loading = false;
      }
    },
  },
};
</script>
